import React from 'react';
import { Typography, Paper, Button } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const Picking: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h5" gutterBottom>
        Picking Masivo de Producción
      </Typography>
      <Button
        variant="contained"
        color="primary"
        startIcon={<AddIcon />}
        onClick={() => navigate('/inventario/picking/nuevo')}
        sx={{ mb: 2 }}
      >
        Nuevo Picking
      </Button>
      {/* Aquí irá la tabla de pickings */}
    </Paper>
  );
};

export default Picking; 